import { atom } from "recoil";

/**
 * This atom keeps track of the currently selected locale.
 */
export const LocaleState = atom({
  key: "LocaleState",
  default: "en",
});
